import axios from 'axios'
import { Message } from 'element-ui'
import Vue from 'vue'
import { baseAPI, timeout } from '@/config'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: baseAPI, // 使用配置文件中的baseAPI
  timeout: timeout, // 使用配置文件中的timeout
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果返回的状态码不是20000，说明接口请求有误
    if (res.code !== 20000) {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误：', error)
    
    // 检查是否是网络错误
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      Message({
        message: '网络连接失败，请检查网络连接或联系管理员',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 使用 nextTick 确保在下一个事件循环中执行路由跳转，避免与当前导航冲突
      Vue.nextTick(() => {
        if (router.currentRoute.name !== 'ErrorPage') {
          router.push({
            name: 'ErrorPage',
            params: { 
              errorType: 'network',
              errorMessage: '网络连接失败，无法连接到服务器'
            }
          }).catch(err => {
            // 忽略导航取消错误
            if (err.name !== 'NavigationDuplicated') {
              console.error('路由跳转失败:', err)
            }
          })
        }
      })
    } else if (error.response) {      // 服务器返回错误状态码
      const status = error.response.status
      let message = '请求失败'
      
      switch (status) {
        case 401:
          message = '未授权，请重新登录'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = `请求失败 (${status})`
      }
      
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      // 其他错误
      Message({
        message: error.message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
    }
    
    return Promise.reject(error)
  }
)

export default service 